import SectionHeading from "./SectionHeading";
import { tips } from "@/mocks/homeContent";

export default function Tips() {
  return (
    <section id="tips" className="w-full py-16 md:py-24 bg-secondary-50">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="Playbook"
          title="安装完成后的使用技巧"
          desc="装好客户端只是第一步，下面这些实用小技巧能帮你更顺畅地播放、追更和投屏，减少等待与流量消耗。"
        />

        <div className="max-w-5xl mx-auto mt-12 flex flex-col divide-y divide-background-200 border border-background-200 rounded-xl overflow-hidden bg-background-50">
          {tips.map((tip) => (
            <article
              key={tip.id}
              className="grid grid-cols-1 md:grid-cols-[80px_200px_1fr] gap-3 md:gap-6 px-5 md:px-8 py-6 hover:bg-background-100/60 transition-colors"
            >
              <span className="font-heading text-2xl md:text-3xl font-bold text-secondary-400">
                {tip.step}
              </span>
              <h3 className="text-base md:text-lg font-bold text-foreground-950 font-heading">
                {tip.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed md:pt-1">{tip.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}